import React from 'react';
import TimeAgo from 'react-timeago';

import CreateGroupModal from 'Components/Networking/Sub/CreateGroupModal';
import {PrimaryButton} from 'Components/Button';
import {ModalTrigger} from 'Components/Modal';

import {User} from 'Services';
import {translation} from 'Services/TranslationHelpers';

import ProfilePic from './ProfilePic';
import Chat from './Chat';

export default class LargeChat extends Chat {
    /**
     * @var displayProfilePic
     * @type {boolean}
     */
    displayProfilePic = true;

    /**
     * @var displayTimestamp
     * @type {boolean}
     */
    displayTimestamp = true;

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {selected_chat} = this.props;

        return (
            <div className="bg-networking-primary border border-networking-primary h-full -mb-40">
                {!selected_chat &&
                    <div className="mt-3 p-4 text-center border-0 text-app-blue">
                        {translation('networking_frontend', 'connect_message')}
                    </div>
                }

                {selected_chat && this.renderSelectedChat()}
            </div>
        )
    }

    /**
     * @method renderSelectedChat
     * @return {*}
     */
    renderSelectedChat() {
        const {new_message} = this.state;
        const {selected_chat} = this.props;

        return (
            <div className='flex h-full flex-col justify-between'>
                <div className="border-b-2 border-white w-full">
                    <div className="flex flex-row justify-between items-center px-4 py-3">
                        <div className="flex flex-row items-center gap-3">
                            <div>
                                <ProfilePic user={selected_chat} />
                            </div>

                            <div className="flex flex-col gap-2 justify-center">
                                <p className="font-bold text-networking-secondary-text">
                                    { selected_chat.name }
                                </p>
                                <p className="fon-thin text-networking-secondary-text -mt-4">
                                    { selected_chat.job_title }
                                </p>
                                <p className="font-thin text-networking-secondary-text -mt-4">
                                    { selected_chat.company }
                                </p>

                                { selected_chat.attendance_type && selected_chat.attendance_type !== '' &&
                                    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${selected_chat.attendance_type === 'Virtual' ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'}`}>
                                        { selected_chat.attendance_type }
                                    </span>
                                }

                                { selected_chat.subtitle && selected_chat.subtitle !== '' &&
                                    <p className="text-sm">
                                        { selected_chat.subtitle }
                                    </p>
                                }
                            </div>
                        </div>

                        { window.base.features.users_can_create_networking_groups &&
                            selected_chat.type === "App\\Models\\NetworkingGroup" &&
                            <div className="justify-self-end">
                                <ModalTrigger
                                    component={CreateGroupModal}
                                    props={{
                                        group_id: selected_chat.id
                                    }}
                                >
                                    <PrimaryButton
                                        text="Edit"
                                    />
                                </ModalTrigger>
                            </div>
                        }
                    </div>
                </div>

                {this.renderMessages()}

                <div className="p-4 flex border-t-2 border-white h-32 ">
                    <textarea
                        value={new_message}
                        onChange={(e) => this.setState({'new_message': e.target.value})}
                        placeholder={translation('networking_frontend', 'new_message')}
                        onKeyDown={this.handleNewMessageKeyDown}
                        ref={this.newMessageRef}
                        className="bg-white border-0 focus:outline-none text-app-blue placeholder-app-blue
                            focus:border-0 focus:ring-0 outline-none w-full px-4"

                    />

                    <button
                        className="w-24 bg-app-blue text-white h-24"
                        onClick={() => this.sendMessage()}
                    >
                        {translation('networking_frontend', 'send_text')}
                    </button>
                </div>
            </div>
        )
    }

    /**
     * @method renderMessage
     * @param {object} message
     * @return {*}
     */
    renderMessage(message) {
        const {selected_chat} = this.props;

        if (!message.user_from_id) {
            return this.renderSystemMessage(message);
        }

        const fromSelf = (User.id === message.user_from_id);

        return (
            <div key={message.id}>
                <div className={`flex ${fromSelf ? 'flex-row-reverse' : ''}`}>
                    {this.displayProfilePic &&
                        <div className="mx-2 mt-3">
                            <ProfilePic
                                user={message.user_from}
                                hide_active_status={fromSelf}
                                size="small"
                            />
                        </div>
                    }

                    <div
                        className={`
                            p-4 m-1 rounded-2xl border w-3/5
                            ${fromSelf ?
                                'bg-app-blue border-app-blue text-white rounded-br-none' :
                                'bg-app-lighter-blue border-app-lighter-blue text-white rounded-bl-none'}
                        `}
                    >
                        <p>
                            {message.message}
                        </p>

                        <div className="mt-2 flex justify-between flex-row">
                            {this.displayTimestamp &&
                                <div className="text-xs self-start text-app-blue">
                                    <TimeAgo date={message.created_at.iso_string}/>
                                </div>
                            }

                            {message.message_to_type !== "App\\Models\\User" && !fromSelf &&
                                <div className="text-xs justify-self-end ml-1">
                                    {message.user_from.name}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
